import React, { useEffect, useRef, forwardRef, useImperativeHandle } from 'react';

export interface SmartEditorProps {
//   onChange?: (content: string) => void;
  defaultValue?: string;
  height?: number;
  width?: string;
}

export interface SmartEditorRef {
  getContent: () => string;
  setContent: (content: string) => void;
}

interface EditorInstance {
  setIR: (content: string) => void;
  getIR: () => string;
  exec: (command: string, args: any[]) => void;
  getWYSIWYGDocument: () => Document | null;
  getRawElements: () => { ir1: HTMLElement | null };
}

interface EditorRef {
  getById: { [key: string]: EditorInstance };
}

declare global {
  interface Window {
    nhn: {
      husky: {
        EZCreator: {
          createInIFrame: (config: any) => void;
        };
      };
    };
    oEditors: EditorRef;
  }
}

const SmartEditor = forwardRef<SmartEditorRef, SmartEditorProps>(({
//   onChange,
  defaultValue = '',
  height = '100vh',
  width = '100%'
}, ref) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const editorRef = useRef<EditorRef>({ getById: {} });
  // const iframeRef = useRef<HTMLIFrameElement>(null);

  const getContent = () => {
    try {
      const editor = editorRef.current.getById['ir1'];
      if (editor) {
        return editor.getIR();
      }
      return '';
    } catch (error) {
      console.error('Error getting content:', error);
      return '';
    }
  };

  const setContent = (content: string) => {
    try {
      const editor = editorRef.current.getById['ir1'];
      if (editor) {
        editor.setIR(content);
      }
    } catch (error) {
      console.error('Error setting content:', error);
    }
  };

  useImperativeHandle(ref, () => ({
    getContent,
    setContent
  }));
  
  useEffect(() => {
    if (!textareaRef.current) return;

    const script = document.createElement('script');
    script.src = '/static/smarteditor/js/service/HuskyEZCreator.js';
    script.async = true;

    const initializeEditor = () => {
      try {
        if (!window.nhn?.husky?.EZCreator) {
          throw new Error('SmartEditor 스크립트가 로드되지 않았습니다.');
        }

        const aAdditionalFontSet = [
          ['Pretendard', 'Pretendard'],
          ["Noto Sans KR", "Noto Sans"],
          ["NanumSquare", "나눔스퀘어"],
          ["Nanum Gothic", "나눔고딕"],
          ["NanumMyeongjo", "나눔명조"],
          ["SCoreDream", "에스코어드림"],
          ["MapoBackpacking", "마포배낭여행체"],
          ['GmarketSans', '지마켓산스'],
          ["MaruBuri", "마루부리"],
          ["Elice Digital Baeum", "엘리시안디지털배움"],
          ["SeoulNamsan", "서울남산"],
          ["GowunDodum", "고운돋움"],
          ["GowunBatang", "고운바탕"],
          ["KorailRoundGothicBold", "코레일둥근고딕"],
          ["OTWelcomeRA", "웰컴체"],
          ["MICEGothic Bold", "MICE고딕"]
        ];

        window.nhn.husky.EZCreator.createInIFrame({
          oAppRef: editorRef.current,
          elPlaceHolder: 'ir1',
          sSkinURI: '/static/smarteditor/SmartEditor2Skin.html',
          htParams: {
            bUseToolbar: true,
            bUseVerticalResizer: false,
            bUseModeChanger: true,
            bSkipXssFilter: true,
            aAdditionalFontList: aAdditionalFontSet,
            fOnBeforeUnload: function() {},
            I18N_LOCALE: 'ko_KR'
          },
          fOnAppLoad: function() {
            const editorInstance = editorRef.current.getById['ir1'];
            const existingIframe = document.querySelector('iframe[src*="SmartEditor2Skin.html"]');
              if (existingIframe instanceof HTMLIFrameElement) {
                editorInstance.exec('RESIZE_EDITING_AREA', [0, height]);
                existingIframe.style.height = `${Number(height) + 57}px`;
                console.log(existingIframe.style.height)
              }
            try {
              if (defaultValue) {
                setContent(defaultValue);
              }
            } catch (error) {
              console.error('Error in fOnAppLoad:', error);
            }
          },
          fCreator: 'createSEditor2'
        });
      } catch (error) {
        console.error('Error initializing editor:', error);
      }
    };

    script.onload = initializeEditor;
    document.head.appendChild(script);

    return () => {
      try {
        if (document.head.contains(script)) {
          document.head.removeChild(script);
        }
        const iframe = document.querySelector('iframe[src*="SmartEditor2Skin.html"]');
        if (iframe) {
          iframe.remove();
        }
      } catch (error) {
        console.error('Error cleaning up editor:', error);
      }
    };
  }, [defaultValue]);

  return (
    <div style={{ width }}>
      <textarea
        ref={textareaRef}
        id="ir1"
        rows={40}
        cols={100}
        style={{ width: '100%', height: '990', display: 'none' }}
      />
      
    </div>
  );
});

export default SmartEditor;
